var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"explain"},[_c('a-divider'),_c('div',{staticClass:"title"},[_vm._v("说明")]),_c('div',[_vm._v(_vm._s(_vm.content))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }